
    import { defineComponent, ref, computed, watch, PropType } from 'vue';
    import { v4 as uuidv4 } from 'uuid';

    interface PaymentItem {
        id: string;
        name: string;
        icon?: string;
        description?: string;
        children?: PaymentItem[];
        inn?: string;
        kpp?: string;
        address?: string;
    }

    export default defineComponent({
        name: 'InvoiceActivatorSelect',
        props: {
            contractors: {
                type: Array as PropType<PaymentItem[]>,
                required: true,
            },
            selectedPayment: {
                type: String,
                required: false,
            }
        },
                 emits: ['select', 'delete-contractor'],
        setup(props, { emit }) {
            const activatorId = 'inv-select-' + uuidv4().slice(0, 8);
            const menuOpened = ref(false);
            const items = computed(() => {
                return [
                    {
                        id: 'card',
                        name: 'Банковская карта',
                        icon: 'mdi-credit-card',
                    },
                                         {
                         id: 'invoice',
                         name: 'ВЫСТАВИТЬ СЧЕТ',
                         description: 'Для Юр. лиц, ИП и самозанятых',
                         icon: 'mdi-file-document-outline',
                         children: [
                             ...props.contractors,
                         ]
                     },
                ]
            })

            const selectedId = ref(props.selectedPayment)

            watch(() => props.selectedPayment, (val) => {
                selectedId.value = val
            })

            const findSelectedItem = (list: PaymentItem[]): PaymentItem | undefined => {
                const findItem = (itemsList: PaymentItem[]) =>
                    itemsList.find(i => String(i.id) === String(selectedId.value));

                let sel = findItem(list);
                if (!sel) {
                    for (const g of list) {
                        if (g.children) {
                            sel = findItem(g.children);
                            if (sel) break;
                        }
                    }
                }
                return sel;
            };

            const selectedItem = computed(() => findSelectedItem(items.value));

            const selectedLabel = computed(() => {
                return selectedItem.value ? selectedItem.value.name : 'Выберите вариант оплаты';
            });

            const optionGlyph = (item?: PaymentItem | null) => {
                if (!item) return '₽';
                if (item.id === 'card') return '₽';
                if (item.id === 'new_invoice') return '+';
                return 'ЮЛ';
            };

            const optionSubtitle = (item?: PaymentItem | null) => {
                if (!item) return '';
                if (item.description) return item.description;
                if (item.inn) return `ИНН ${item.inn}`;
                return '';
            };

            const selectedGlyph = computed(() => optionGlyph(selectedItem.value));
            const selectedDescription = computed(() => optionSubtitle(selectedItem.value));

            const select = (item: PaymentItem) => {
                selectedId.value = item.id
                menuOpened.value = false
                emit('select', item.id)
            };

            const isSelected = (item: PaymentItem) =>
                String(item.id) === String(selectedId.value);

            const openGroups = ref<Record<string, boolean>>({});
            const isGroupActive = (item: PaymentItem) =>
                Boolean(openGroups.value[item.id]);

            const toggleGroup = (item: PaymentItem, val?: boolean) => {
                openGroups.value = {
                    ...openGroups.value,
                    [item.id]: val ?? !isGroupActive(item),
                };
            };

            const closeMenu = () => {
              menuOpened.value = false;
            };


            const deleteContractor = (contractor: PaymentItem) => {
               emit('delete-contractor', contractor);
               menuOpened.value = false;
            };

         return {
                 activatorId,
                 menuOpened,
                 selectedLabel,
                 selectedGlyph,
                 selectedDescription,
                 optionGlyph,
                 optionSubtitle,
                 select,
                 isSelected,
                 isGroupActive,
                 toggleGroup,
                 closeMenu,
                 selectedId,
                 items,
                 deleteContractor
             };
        },
    });
